<div *ngIf="loaderFullScreenService.loading$ | async" class="fullscreen" data-cy="loader-fullscreen">
    <div class="icon-wrapper">
        <img class="icon" src="assets/loader-fullscreen.gif">
    </div>
    <div class="title">
        UD loading
    </div>
</div>
